import(/* webpackMode: "eager", webpackExports: ["AlgoliaProvider"] */ "/app/src/modules/product/components/AlgoliaSearch/AlgoliaProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShoppingListProvider"] */ "/app/src/modules/shopping-list/context/ShoppingListContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/shopping-list/pages/ShoppingListPageTemplate.tsx");
